export default async (to, from, next) => {
  document.title =
    (to.meta.title || to.name) + " | " + process.env.VUE_APP_PROJECT_NAME;

  if (to.name != from.name) window.scrollTo(0, 0);

  next();
};
